import React, { useState } from 'react';
import { Button } from '../../design-system/components/Button';
import { useCookieConsentStore } from './useCookieConsentStore';
import { CookiePreferencesPopin } from './CookiePreferencesPopin';
import cookiesIcon from './cookiesicon.svg';
import './CookieBanner.css';

/* ============================================================
   CookieBanner — bandeau de consentement affiché en bas à
   droite tant que l'utilisateur n'a fait aucun choix
   (premier landing). « Customize » ouvre la popin de
   préférences ; tout choix ferme définitivement le bandeau
   (persistance localStorage, voir useCookieConsentStore).
   ============================================================ */
export const CookieBanner: React.FC = () => {
  const analytics = useCookieConsentStore((s) => s.analytics);
  const acceptAll = useCookieConsentStore((s) => s.acceptAll);
  const rejectNonEssential = useCookieConsentStore((s) => s.rejectNonEssential);
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  // Choix déjà enregistré → rien à afficher
  if (analytics !== null) return null;

  return (
    <>
      <aside className="CookieBanner" role="dialog" aria-label="Cookie consent">
        <div className="CookieBanner__header">
          <img className="CookieBanner__icon" src={cookiesIcon} alt="" />
          <h2 className="CookieBanner__title">We value your privacy</h2>
        </div>
        <p className="CookieBanner__text">
          Rabbit Prompt uses cookies to enable core features and analyze platform traffic.
        </p>
        <div className="CookieBanner__actions">
          <Button variant="outline" size="md" onClick={rejectNonEssential}>
            Reject
          </Button>
          <Button variant="outline" size="md" onClick={() => setPreferencesOpen(true)}>
            Customize
          </Button>
          <Button variant="primary" size="md" onClick={acceptAll}>
            Accept All
          </Button>
        </div>
      </aside>
      <CookiePreferencesPopin
        isOpen={preferencesOpen}
        onClose={() => setPreferencesOpen(false)}
      />
    </>
  );
};

export default CookieBanner;
